import isEmpty from 'lodash-es/isEmpty';
import { INCOME_VERIFICATION } from 'src/utils/constants';
import {
  SelectionCard,
  SelectionCardActions,
  SelectionCardContent,
  SelectionCardText,
  SelectionCardTitle,
} from '@components/SelectionCard';
import { css } from '@emotion/css';
import { Box } from '@spark-web/box';
import { Divider } from '@spark-web/divider';
import { ExclamationIcon } from '@spark-web/icon';
import { Inline } from '@spark-web/inline';
import { Stack } from '@spark-web/stack';
import { Text } from '@spark-web/text';
import { TextLinkButton } from '@spark-web/text-link';
import { BankAccountsList } from './BankAccountsList';
import { BankIncomeSources } from './hooks';

interface OpenBankingIncomeReviewErrorProps {
  isOpenBankingConnecting?: boolean;
  onIncomeManualEntry?: () => void;
  onOpenBankingConnect?: () => void;
  bankIncomeSources: BankIncomeSources;
}

export default function OpenBankingIncomeReviewError({
  isOpenBankingConnecting,
  onIncomeManualEntry,
  onOpenBankingConnect,
  bankIncomeSources,
}: OpenBankingIncomeReviewErrorProps) {
  const { AUTOFILL_WITH_CDR_ACTION, IMCOME_SYNC_ERROR_TITLE, IMCOME_SYNC_ERROR_DESCRIPTION } = INCOME_VERIFICATION;
  return (
    <Stack background="secondaryLow" padding="small" borderRadius="medium" gap="small">
      <SelectionCard border="secondary" display="block" paddingY="large">
        <ExclamationIcon size="large" tone="secondary" />
        <SelectionCardContent gap="large">
          <Stack gap="xlarge" marginTop="large">
            <Box>
              <SelectionCardTitle size="large">{IMCOME_SYNC_ERROR_TITLE}</SelectionCardTitle>
            </Box>
            <SelectionCardText size="standard">{IMCOME_SYNC_ERROR_DESCRIPTION}</SelectionCardText>
            <Inline gap="medium" alignY="center">
              <SelectionCardActions
                onClick={onOpenBankingConnect}
                loading={isOpenBankingConnecting}
                disabled={isOpenBankingConnecting}
              >
                {AUTOFILL_WITH_CDR_ACTION}
              </SelectionCardActions>
              <Text>
                <TextLinkButton
                  weight="regular"
                  tone="primaryActive"
                  className={css({
                    textDecoration: 'underline',
                    cursor: 'pointer',
                  })}
                  onClick={onIncomeManualEntry}
                >
                  Enter all income details manually
                </TextLinkButton>
              </Text>
            </Inline>
          </Stack>
          {!isEmpty(bankIncomeSources) && (
            <>
              <Divider />
              <BankAccountsList bankIncomeSources={bankIncomeSources} />
            </>
          )}
        </SelectionCardContent>
      </SelectionCard>
    </Stack>
  );
}
